import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { WifiKeyDto } from "../../dtos/WifiKeyDto";
import { useVillageWifiHttp } from "./hooks/useVillageWifiHttp";
import { WifiDetails } from "./WifiDetails";
import { ResidentDto } from "../../dtos/ResidentDto";
import { SearchBhpEmployeeContractor } from "./SearchBhpEmployeeContractor";
import { CreateResidentWifiKey } from "./CreateResidentWifiKey";
import { LatestDeviceSessions } from "./LatestDeviceSessions";
import { DeviceSessionDto } from "./dtos/DeviceSessionDto";
import { Asset } from "../../data/Asset";


export const ResidentWifiKey : React.FC = ( ) => {

    const [ isLoadingWifiKey, setIsLoadingWifiKey ] = useState< boolean >( false );
    const [ isLoadingSessions, setIsLoadingSessions ]  = useState< boolean >( false );
    const [ latestDeviceSessions, setLatestDeviceSessions ] = useState< DeviceSessionDto[ ] >( [ ] );
    const [ resident, setResident ] = useState< ResidentDto >( );
    const [ residentId, setResidentId ] = useState< number >( );
    const [ wifiKey, setWifiKey ] = useState< WifiKeyDto >( );
    const [ wifiKeyNotExist, setWifiKeyNotExist ] = useState< boolean >( false );

    const { getLatestDeviceSessions, getResidentWifiKey } = useVillageWifiHttp( );


    const handleCreateWifiKey = ( wifiKeyDto: WifiKeyDto | undefined ) => {

        setWifiKeyNotExist( false );
        setWifiKey( wifiKeyDto );

    };


    const handleDeviceSessionsClick = async( residentId: number ) => {

        setLatestDeviceSessions( [] );

        setResidentId( residentId );
        
        setIsLoadingSessions( true );
        const deviceSessionDtos = await getLatestDeviceSessions( residentId );
        setIsLoadingSessions( false );

        if(deviceSessionDtos ){

            setLatestDeviceSessions( deviceSessionDtos );

        }

    };
    

    const handleSelectResident = async ( resident : ResidentDto | undefined ) => {

        setResident( resident );
        setLatestDeviceSessions( [] );
        setWifiKeyNotExist( false );

        if( !resident ) {

            setWifiKey( undefined );
            return;

        }

        setIsLoadingWifiKey( true );
        
        const wifiKeyDto = await getResidentWifiKey( ( resident as ResidentDto ).asset, (resident as ResidentDto).employeeId );

        setIsLoadingWifiKey( false );

        if( wifiKeyDto ) {

            setWifiKey( wifiKeyDto );

        } else {

            setWifiKey( undefined );
            setWifiKeyNotExist( true );

        }

    };


    return(

        <>
        
            <Stack justifyContent="center" spacing={ 1 } sx={{ alignItems :"center" }}>
            
                <SearchBhpEmployeeContractor assets={[ Asset.Niw, Asset.Waio ]} onSelectResident={ handleSelectResident } />

                {

                    resident
                        &&    
                    <Stack sx={{ margin: '10px' }}>
                        
                        {
                    
                            isLoadingWifiKey
                                ?
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                                sx={{ marginBottom: '30px', marginTop: '10px' }}
                                width="100%"
                            >
                            
                                <CircularProgress size={40} sx={{color: '#e65400'}}/>

                            </Box>
                                :   
                            <>

                                { wifiKey  && <WifiDetails resident={ resident } wifiKeyDto={ wifiKey } deviceSessionsClick={ handleDeviceSessionsClick } /> }

                                { wifiKeyNotExist && <CreateResidentWifiKey onCreateWifiKey={ handleCreateWifiKey } resident={ resident } /> }

                            </>

                        }

                    </Stack>

                }

                {
                    ( resident &&  latestDeviceSessions.length > 0 )
                        &&
                    <Stack sx={{ margin: '40px !important' }}>
                        <Typography align="center" sx={{ fontWeight: 'bold' }}>
                            Device List
                        </Typography>

                        <LatestDeviceSessions latestDeviceSessions={ latestDeviceSessions } />
                    </Stack>
                }

                {

                    isLoadingSessions
                        &&
                    <Box display="flex" justifyContent="center">
                        <CircularProgress size="30px" sx={{ marginTop: '5px', color: '#e65400'}}/>
                    </Box>

                }

            </Stack>
       
        </>

    );

};